import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useEventSubscribe } from '../events';
import { UnlimitedStudioModal } from './UnlimitedStudioModal';
// Single app-level mount of the LandScope Atlas (unlimited) modal, openable from
// anywhere via the 'atlas:open' event (e.g. the start-demo confirm). Defaults to
// the active-demo $449 framing.
export const GlobalAtlasModal = () => {
    var _a, _b;
    const [state, setState] = useState(null);
    useEventSubscribe('atlas:open', (payload) => {
        var _a, _b;
        setState({
            demoActive: (_a = payload === null || payload === void 0 ? void 0 : payload.demoActive) !== null && _a !== void 0 ? _a : true,
            // Left undefined when the opener has no price in hand; the modal then
            // reads the catalog itself rather than falling back to a literal.
            unlockPriceCents: payload === null || payload === void 0 ? void 0 : payload.unlockPriceCents,
            projectContext: (_b = payload === null || payload === void 0 ? void 0 : payload.projectContext) !== null && _b !== void 0 ? _b : true,
        });
    }, []);
    return (_jsx(UnlimitedStudioModal, { isOpen: state !== null, onClose: () => setState(null), demoActive: (_a = state === null || state === void 0 ? void 0 : state.demoActive) !== null && _a !== void 0 ? _a : true, unlockPriceCents: state === null || state === void 0 ? void 0 : state.unlockPriceCents, projectContext: (_b = state === null || state === void 0 ? void 0 : state.projectContext) !== null && _b !== void 0 ? _b : true }));
};
